const Radar = require('./radar');
require('./sentry');
const CloudApi = require('./CloudApi');
const admitad = require('lib/admitad');

window.__cloudApi__.___ready(new CloudApi());

const radar = Radar.group('landings');

radar.add('build_loaded');
radar.send();

admitad.saveAdmitadId();
